import '../views/styles/global.css'
import '../views/styles/scss/index.scss'
import { Provider } from 'react-redux'
import { useStore } from '@/src/application/store'
import ClientErrorBoundary from '@/src/views/error-handling/ClientErrorBoundary'
import ClientErrorListeners from '@/src/views/error-handling/ClientErrorListeners'
import MonitoringErrorBoundary from '@/src/views/error-handling/MonitoringErrorBoundary'
import { initMonitoring, setupAxiosInterceptors } from '@/src/lib/monitoring'

import type { AppProps } from 'next/app'
import type { Page } from '../types/page'

initMonitoring()
setupAxiosInterceptors()

type Props = AppProps & {
  Component: Page
}
const BRIBrain = ({ Component, pageProps }: Props) => {
  const getContent = () => {
    return Component.getLayout?.(<Component {...pageProps} />) ?? <Component {...pageProps} />;
  };
  console.log("=======_APP==========")
  console.log("process.env.NEXT_PUBLIC_BASE_URL", process.env.NEXT_PUBLIC_BASE_URL)
  console.log("process.env.NEXT_PUBLIC_MAIN_URL", process.env.NEXT_PUBLIC_MAIN_URL)
  console.log("process.env.NEXT_PUBLIC_MOBILE_URL", process.env.NEXT_PUBLIC_MOBILE_URL)

  const store = useStore(pageProps.initialReduxState)
  return (
    <>
      <ClientErrorListeners />
      <MonitoringErrorBoundary componentName="App">
        <ClientErrorBoundary>
          <Provider store={store}>
            {getContent()}
          </Provider>
        </ClientErrorBoundary>
      </MonitoringErrorBoundary>
    </>
  );
}
export default BRIBrain
